import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/config/i18n';
import '@/config/sentry';
import '@/uikit/styles/main.scss';

import App from './App';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
